import {initAjaxForm} from "../../../src/js/core/forms";

export const initRequestForm = () => {
    initForm();

    if (typeof TourArrayWithDates === 'undefined') {
        return
    }

    const selectTour = document.getElementById('select-tour');
    const selectDate = document.getElementById('select-date');
    const selectDateWrapper = document.getElementById('select-date-wrapper');

    if (!selectTour) {
        return
    }

    selectTour.addEventListener('change', function() {
        const selectedOption = this.selectedOptions[0];
        const selectedValue = selectedOption.getAttribute('data-id');
        const dates = TourArrayWithDates[selectedValue] || [];

        selectDate.innerHTML = '<option value="">Choose a date</option>';

        // console.log('dates', dates)

        dates[0].forEach(date => {
            const option = document.createElement('option');
            option.value = date['date'];
            option.textContent = date['date'] + ' - €' + date['price'];
            selectDate.appendChild(option);
        });


        if (dates[0].length === 0) {
            selectDate.innerHTML = '<option value="">No dates available</option>';
            selectDateWrapper.classList.add('inactive')
        } else {
            selectDateWrapper.classList.remove('inactive')
        }
    });
}

const initForm = () => {
    const form = document.getElementById('request-form');

    if (!form) {
        return
    }

    initAjaxForm(form, 'submit_request_form', '/request-thankyou')
}
